/**
 * @deprecated This file is Polish-only and being phased out in favor of the
 * bilingual { english, polish } structure in `./v2/facilityLabels.ts` (see
 * docs/CONTENT_LOCALIZATION_GUIDE.md). Do not add new keys here — add them
 * to v2/facilityLabels.ts instead, and migrate existing keys/call-sites over
 * time. Once every key here has a v2 equivalent and every call site is
 * migrated, delete this file and move v2/facilityLabels.ts up to
 * constants/facilityLabels.ts in its place.
 */
export const FACILITY_LABELS = {
  // Form title
  FORM_TITLE: 'Dodaj placówkę',
  FACILITY_TITLE: 'Placówki',
  FACILITY_DETAILS_TITLE: 'Dane placówki',

  // Card metadata
  CREATED_DATE_LABEL: 'Data utworzenia',
  SECTION_FACILITY_USER: 'Pracownik',

  // Section headings
  SECTION_BASIC_DETAILS: 'Podstawowe dane',
  SECTION_ADDRESS: 'Dane adresowe',
  SECTION_TAX: 'Dane podatkowe',
  SECTION_EQUIPMENT: 'Aparatura',

  // Field labels
  FIELD_NAME: 'Imię i nazwisko',
  FIELD_EDIT_NAME: 'Nazwa',
  FIELD_NIP: 'NIP',
  FIELD_PHONE: 'Numer telefonu',
  FIELD_ADDRESS1: 'Adres (linia 1)',
  FIELD_ADDRESS2: 'Adres (linia 2)',
  FIELD_CITY: 'Miejscowość',
  FIELD_STATE: 'Województwo',
  FIELD_ZIP: 'Kod pocztowy',
  FIELD_COUNTRY: 'Kraj',
  FIELD_OPTIONAL: '(Opcjonalne)',

  // Buttons
  ADD_EQUIPMENT_BUTTON: '+ Dodaj kolejny sprzęt',
  ADD_EQUIPMENT_BUTTON_PRIMARY: 'Dodaj aparaturę',
  ADD_FACILITY_BUTTON: '+ Dodaj kolejną placówkę',
  SUBMIT_BUTTON: 'Dodaj placówkę',
  SUBMIT_BUTTON_LOADING: 'Dodawanie...',
  EDIT_SUBMIT_BUTTON: 'Zapisz',
  EDIT_SUBMIT_BUTTON_LOADING: 'Zapisywanie…',
  CANCEL_BUTTON: 'Anuluj',
  ADD_FACILITY_SUCCESS: 'Placówka została pomyślnie dodana.',
  ADD_EQUIPMENT_SUCCESS: 'Aparatura została pomyślnie dodana.',
  EDIT_FACILITY_SUCCESS: 'Dane placówki zostały pomyślnie zaktualizowane.',
  EDIT_EQUIPMENT_SUCCESS: 'Dane aparatury zostały pomyślnie zaktualizowane.',

  // Employee form
  SECTION_EMPLOYEE_FORM: 'Dane pracownika',
  FIELD_EMPLOYEE_NAME: 'Imię i nazwisko',
  FIELD_EMPLOYEE_EMAIL: 'Adres e-mail',
  FIELD_EMPLOYEE_PHONE: 'Numer telefonu',
  FIELD_EMPLOYEE_GENDER: 'Płeć',
  FIELD_EMPLOYEE_GENDER_MALE: 'Mężczyzna',
  FIELD_EMPLOYEE_GENDER_FEMALE: 'Kobieta',
  FIELD_EMPLOYEE_ACADEMIC_TITLE: 'Tytuł naukowy',
  ADD_EMPLOYEE_BUTTON: 'Dodaj pracownika',
  ADD_EMPLOYEE_BUTTON_LOADING: 'Adding Employee...',
  ADD_EMPLOYEE_SUCCESS: 'Pracownik został pomyślnie dodany.',
  EDIT_EMPLOYEE_MODAL_TITLE: 'Edytuj pracownika',
  EDIT_EMPLOYEE_FIELD_USER_ID: 'ID pracownika',
  EDIT_EMPLOYEE_SAVE_BUTTON: 'Zapisz',
  EDIT_EMPLOYEE_SAVE_BUTTON_LOADING: 'Zapisywanie...',
  EDIT_EMPLOYEE_SUCCESS: 'Dane pracownika zostały pomyślnie zaktualizowane.',

  // View facility
  VIEW_TITLE: 'Podgląd placówki',
  VIEW_NAV_BASIC: 'Podstawowe informacje',
  FIELD_FACILITY_ID: 'ID placówki',
  FIELD_COUNTRY_CODE: 'Kod kraju',
  FIELD_STATUS: 'Status',
  SECTION_CONTACT: 'Dane kontaktowe',
  SECTION_STATISTICS: 'Statystyki',
  FIELD_EQUIPMENT_COUNT: 'Liczba urządzeń',
  FIELD_USER_COUNT: 'Liczba pracowników',
  STATUS_ACTIVE: 'Aktywny',
  STATUS_INACTIVE: 'Nieaktywny',

  // Activate / deactivate (facility)
  ACTIVATE_SUCCESS: 'Placówka została pomyślnie aktywowana.',
  DEACTIVATE_SUCCESS: 'Placówka została pomyślnie dezaktywowana.',
  ALREADY_ACTIVE: 'Placówka jest już aktywna.',
  ALREADY_INACTIVE: 'Placówka jest już dezaktywowana.',

  // Activate / deactivate (employee)
  ACTIVATE_EMPLOYEE_SUCCESS: 'Pracownik został pomyślnie aktywowany.',
  DEACTIVATE_EMPLOYEE_SUCCESS: 'Pracownik został pomyślnie dezaktywowany.',
  TOGGLE_EMPLOYEE_DISABLED_FACILITY:
    'Nie można zmienić statusu pracownika, ponieważ placówka jest nieaktywna.',
  TOGGLE_EMPLOYEE_DISABLED_CLIENT:
    'Nie można zmienić statusu pracownika, ponieważ klient jest nieaktywny.',
} as const;
